import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Opportunity = lazy(() => import("@/pages/DealAndPipeline/Opportunity"));

const DealAndPipelineRoute: RouteConfig = {
    path: "/opportunities",
    element: <Opportunity />,
    pageName: "Deals & Pipeline",
    sidebar: { show: true, icon: "/assets/media/dealLogo.svg" },
    permission: ["DealsView", "OpportunityViewAll"],
}

export default DealAndPipelineRoute;